module.exports = __webpack_public_path__ + "img/altes_heim.7c5278aa.jpg";